import React, { useState, useEffect, useRef } from 'react';
import ApproverPage from './pages/ApproverPage';
import { getCurrentUser, initAuthAutoRefresh } from './services/auth';

function App() {
    const [userAlias, setUserAlias] = useState(null);
    const [isAuthLoading, setIsAuthLoading] = useState(true);
    const authCalled = useRef(false);

    useEffect(() => {
        if (authCalled.current) return;
        authCalled.current = true;

        getCurrentUser()
            .then(alias => {
                if (alias) {
                    setUserAlias(alias);
                    localStorage.setItem('approver_alias', alias.toLowerCase());
                    // Wire proactive silent-refresh (visibility/focus/interval) so a token
                    // never silently expires on an idle tab — fixes the "came back later,
                    // it failed" case where the setTimeout-based refresh was suspended.
                    initAuthAutoRefresh();
                }
                setIsAuthLoading(false);
            })
            .catch(err => {
                console.error('Auth error:', err);
                setIsAuthLoading(false);
            });
    }, []);

    if (isAuthLoading) {
        return (
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                height: '100vh', flexDirection: 'column', gap: '12px',
                backgroundColor: '#1a1a2e', color: '#fff'
            }}>
                <div className="spinner"></div>
                <p style={{ color: '#aaa', fontSize: '14px' }}>Authenticating via Midway...</p>
            </div>
        );
    }

    if (!userAlias) {
        return (
            <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                height: '100vh', flexDirection: 'column', gap: '12px',
                backgroundColor: '#1a1a2e', color: '#fff'
            }}>
                <p style={{ color: '#ff6b6b', fontSize: '16px' }}>⚠️ Authentication required</p>
                <p style={{ color: '#aaa', fontSize: '13px' }}>Please authenticate via Midway to access the Approver Portal.</p>
                <button
                    onClick={() => { sessionStorage.clear(); window.location.reload(); }}
                    style={{
                        padding: '8px 20px', borderRadius: '6px', fontSize: '13px',
                        fontWeight: '600', cursor: 'pointer', border: 'none',
                        backgroundColor: '#ff9900', color: '#000'
                    }}
                >
                    🔄 Retry Authentication
                </button>
            </div>
        );
    }

    return <ApproverPage userAlias={userAlias} />;
}

export default App;
